import { mapGetters, mapActions } from 'vuex'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
const ics = require('ics-browser')

export default {
  name: 'CcCountsCalendar',
  components: {
    FullCalendar
  },
  computed: {
    ...mapGetters({
      events: 'getEvents'
    }),
    sortedEvents () {
      console.log(this.events)
      const events = [...this.events]
      for (var x = 0; x < events.length; x++) {
        events[x].start = new Date(events[x].start)
        events[x].end = new Date(events[x].end)
      }
      return events.sort((a, b) => {
        if (a.start > b.start) {
          return 1
        }
        return -1
      })
    }
  },
  data () {
    return {
      selectedEvent: { title: '', start: new Date(), end: new Date(), extendedProps: {} },
      eventModal: false,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        eventSources: {
          url: 'https://dcf.wisconsin.gov/rest/childcare/events?_format=json',
          type: 'GET'
        },
        eventClick: this.eventClicked
      },
      listView: false
    }
  },
  methods: {
    ...mapActions({
      getEvents: 'getAllEvents'
    }),
    eventClicked (e) {
      console.log(e)
      this.eventModal = true
      this.selectedEvent = e.event
    },
    makeSelectedEvent (event) {
      this.selectedEvent = { ...event, extendedProps: { body: event.body, location: event.location, link: event.link, nid: event.nid } }
    },
    addToCalendar () {
      const difference = (this.selectedEvent.end - this.selectedEvent.start)
      const hours = Math.floor(difference / 3600000)
      const minutes = Math.floor(difference / 60000) - (hours * 60)
      const icsEvent = {
        description: this.decodeHtml(this.selectedEvent.extendedProps.body).replace(/(<([^>]+)>)/gi, ''),
        location: this.selectedEvent.extendedProps.location,
        start: [
          this.selectedEvent.start.getFullYear(),
          this.selectedEvent.start.getMonth() + 1,
          this.selectedEvent.start.getDate(),
          this.selectedEvent.start.getHours(),
          this.selectedEvent.start.getMinutes()
        ],
        uid: this.selectedEvent.extendedProps.nid,
        url: 'https://dcf.wisconsin.gov' + this.selectedEvent.extendedProps.link,
        title: this.selectedEvent.title,
        duration: { hours: hours, minutes: minutes }
      }
      ics.createEvent(icsEvent, (err, val) => {
        if (err) {
          console.log(err)
        }
        var filename = icsEvent.title + '.ics'
        var blob = new Blob([val], { type: 'text/calendar' })
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, filename)
        } else {
          var a = document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          a.download = filename
          a.click()
        }
      })
    },
    decodeHtml: function (html) {
      var txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    }
  },
  created () {
    this.getEvents()
  }
}
